declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '1055579947634892'

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView(): void {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackInitiateCheckout(): void {
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout')
  }
}
